import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { lazy, Suspense, useState } from 'react';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import retry from '../../utils/webpack/chunkRetry';
import MediaManager from '../../MediaPopup/MediaManager';
import Flex from '@wix/da-ds/pkg/Flex';
import { MediaSourceType } from '../../MediaPopup';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { DeviationResourceType } from '../../types/deviation';
import { BiData } from '@wix/da-bi/pkg/events';
const LoadableInit = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "tiercreator" */ '../redux/creator/ModuleLoadable')));
const TierManageContentButton = (_param)=>{
    var { type, tierDeviation, profileOwner, className } = _param, props = _object_without_properties(_param, [
        "type",
        "tierDeviation",
        "profileOwner",
        "className"
    ]);
    var _tierDeviation_tier_stats, _tierDeviation_tier;
    const { t } = useTranslation();
    const [showMM, setShowMM] = useState(false);
    const tierItemsCount = (tierDeviation === null || tierDeviation === void 0 ? void 0 : (_tierDeviation_tier = tierDeviation.tier) === null || _tierDeviation_tier === void 0 ? void 0 : (_tierDeviation_tier_stats = _tierDeviation_tier.stats) === null || _tierDeviation_tier_stats === void 0 ? void 0 : _tierDeviation_tier_stats[type]) || 0;
    const onManagementDone = ()=>{
        setShowMM(false);
        props.pushLoadingModal();
        // Pressing ESC key to close the MM cancels the reload.
        // Let's postpone it by 1 cycle
        setTimeout(()=>{
            window.location.href = Url.userSubscriptionsPath({
                username: profileOwner.username,
                tierDeviationId: tierDeviation.deviationId,
                tierContentType: type
            });
        }, 1);
    };
    return /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "TierManageContentButton"
    }, /*#__PURE__*/ React.createElement(Flex, {
        className: className
    }, /*#__PURE__*/ React.createElement(GhostButton, {
        size: 'medium',
        variant: 'main',
        onClick: ()=>setShowMM(true),
        biData: BiData({
            evid: 532,
            typeid: DeviationResourceType.TIER,
            itemid: tierDeviation.deviationId,
            button_name: type
        })
    }, type === 'deviations' ? t(tierItemsCount > 0 ? 'deviation.tier.editContent.deviations' : 'deviation.tier.addContent.deviations') : t(tierItemsCount > 0 ? 'deviation.tier.editContent.posts' : 'deviation.tier.addContent.posts')), showMM && /*#__PURE__*/ React.createElement(Suspense, {
        fallback: null
    }, /*#__PURE__*/ React.createElement(LoadableInit, null), /*#__PURE__*/ React.createElement(MediaManager, {
        title: t(type === 'deviations' ? 'mediapopup.tierManager.deviations' : 'mediapopup.tierManager.posts'),
        allowUploads: false,
        tier: tierDeviation,
        withAddDeviationsPopupOpen: tierItemsCount === 0,
        onClose: onManagementDone,
        onDone: onManagementDone,
        initialMediaSource: type === 'deviations' ? MediaSourceType.TIER_DEVIATIONS : MediaSourceType.TIER_POSTS
    }))));
};
TierManageContentButton.displayName = 'TierManageContentButton';
export default TierManageContentButton;
